import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { Child } from '../../../interfaces/child.interface';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-pin-input-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './pin-input-modal.component.html',
  styleUrls: ['./pin-input-modal.component.scss']
})
export class PinInputModalComponent {
  numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  enteredPin = '';
  showError = false;

  constructor(
    public dialogRef: MatDialogRef<PinInputModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { child: Child }
  ) {}

  enterNumber(num: number) {
    if (this.enteredPin.length < 4) {
      this.enteredPin += num;
      if (this.enteredPin.length === 4) {
        this.submitPin();
      }
    }
  }

  clear() {
    this.enteredPin = '';
  }

  isComplete() {
    return this.enteredPin.length === 4;
  }

  submitPin() {
    if (this.enteredPin === this.data.child.pin) {
      this.dialogRef.close(this.enteredPin);
    } else {
      this.showError = true;
      this.enteredPin = '';  // Clear the incorrect PIN
    }
  }
} 